import { createContext, useCallback, useContext, useEffect, useRef, type ReactNode } from "react";

/** Lets a page tell the phone top bar what its large title is, and whether it has scrolled under the bar. */
export interface Chrome { report: (title: string | null, under: boolean) => void }

const ChromeContext = createContext<Chrome>({ report: () => {} });

export const ChromeProvider = ({ report, children }: { report: Chrome["report"]; children: ReactNode }) => (
  <ChromeContext.Provider value={{ report }}>{children}</ChromeContext.Provider>
);

/** Pass the result to `<LargeTitle onUnderBarChange>`. Clears itself when the page unmounts. */
export function useLargeTitleChrome(title: string): (under: boolean) => void {
  const { report } = useContext(ChromeContext);
  const titleRef = useRef(title);
  titleRef.current = title;
  useEffect(() => { report(title, false); return () => report(null, false); }, [report, title]);
  return useCallback((under: boolean) => report(titleRef.current, under), [report]);
}
